var render = function render(){var _vm=this,_c=_vm._self._c;return _c('resource-box',{attrs:{"name":"回收品类分布"}},[_c('div',{staticClass:"recyLing",attrs:{"slot":"content"},slot:"content"},[(_vm.materials.length)?_c('div',{staticClass:"echarts",attrs:{"id":"mains"}}):_c('el-empty',{staticStyle:{"height":"inherit"},attrs:{"image":require('@/assets/recycling/index/empty.svg'),"description":"暂无数据"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }